import React from "react";
import {img} from "@/utils/pluginImg.js";

// Ported from plugin customComponent/flightDelayedContent.jsx
export function FlightDelayedContent() {
    return (
        <div className="hopn-airport-perks">
            <div className="hopn-perks-highlight">
                <h5>Flight Delayed? No Problem:</h5>
                <div className="hopn-perks-highlight-item">
                    <img src={img("flightDelay.svg")} alt="Flight Delay"/>
                    <span>hop'n tracks your flight and adjusts your pickup time automatically. Whether it's a flight delay or baggage hold-up, we've got you covered. Simply choose "By flight arrival" and let your navigator ensure a smooth pickup experience</span>
                </div>
            </div>

            <div className="hopn-perks-highlight second">
                <h5>Lost baggage or delays</h5>
                <div className="hopn-perks-highlight-item">
                    <img src={img("Infinity.svg")} alt="Unlimited Wait"/>
                    <span>Lost baggage? Customs or immigration delays? No worries—your driver will wait as long as needed</span>
                </div>
            </div>
        </div>
    );
}

export default FlightDelayedContent;
